function base10to64(base10) {
		const order = "0123456789-abcdefghijklmnopqrstuvwxyz_ABCDEFGHIJKLMNOPQRSTUVWXYZ"
		let str = ""
		let num = base10
		if (num) {
			while (num) {
				const d = num % 64;
				str = order[d] + str;
				num = Math.floor(num / 64);
			}
			return str
		} else {
			return "0"
		}
	}
	
function validateUrl(value){
		const result = /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(
		value
		);
		if (!result){
			return `https://${value}`
		} else {
			return value
		}
}

function calculateDays(unixTime){
	// const ageInUnix = Date.now() - unixTime 
	const age = Math.round(unixTime / (60*60*24*10)) / 100
	return age
}

function sortGeoClicks(rawGeoObject){
	
		let sortable = [];

		for (var geoLocation in rawGeoObject) {
			sortable.push([geoLocation, rawGeoObject[geoLocation]]);
		}

		sortable.sort(function(a, b) {
			return b[1] - a[1];
		});
	if (Object.keys(rawGeoObject).length >4){
		let top4Geos = sortable.slice(0, 4)
		let otherGeos = sortable.slice(4, sortable.length)
		
		let otherGeoClicks = 0
		for(let geo in otherGeos){
			otherGeoClicks += otherGeos[geo][1]
		}

		let fiveGeos = top4Geos.concat([["Others", otherGeoClicks]])
		fiveGeos.sort(function(a, b) {
			return b[1] - a[1];
		});
		return fiveGeos
	}else {
		sortable.sort(function(a, b) {
			return b[1] - a[1];
		});
		return sortable
	}
	
	

}

function cleanGivenUrl(rawGivenUrl){
	let cleanedUrlArray = rawGivenUrl.match(/\bhttps?:\/\/\S+/gi);

	if(cleanedUrlArray.length > 1){
		return 2
	} else if(cleanedUrlArray.length === 0){
		return 0
	} else{
		return cleanedUrlArray[0]
	}
}
    
export {base10to64, validateUrl, calculateDays, sortGeoClicks, cleanGivenUrl};